import { useCurrentUserStore } from '~/stores/user-store.store.ts'

export function useUserData() {
  const store = useCurrentUserStore()
  const globImages: GlobImageI = import.meta.glob('~/assets/images/pages/avatar/*', { eager: true })
  const iconImgUrl = '/assets/images/pages/avatar'
  const currentUser = computed(() => {
    return store.data
  })

  const avatar = computed(() => {
    return currentUser.value?.avatar
      ? getImageURL(globImages, `avatar${currentUser.value?.avatar?.toString()}`, iconImgUrl, 'png')
      : getImageURL(globImages, 'avatar1', iconImgUrl, 'png')
  })

  const currentBalance = computed(() => {
    return store.getWalletUser()
  })

  const currentBalanceFormat = computed(() => {
    return NumberUtils.formatNumberWithCommas(currentBalance.value)
  })

  return {
    avatar,
    store,
    currentUser,
    currentBalanceFormat
  }
}
